import axios from 'axios';

// Use the Cloudflare Workers URL as the base, fallback to environment variable
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8787';
const API_BASE_URL = `${BACKEND_URL}/api`;

// Create axios instance with baseURL
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// Response interceptor for global error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[API Response Error]', error);
    if (error.response && error.response.status === 401) {
      // Optional: Redirect to login or clear token
      // localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE_URL };
